/* The RŌZ Guide on Shopify — behavior layer.
   Ported from roz-guide (Astro): TableOfContents scroll-spy, KeyTakeaways
   jump list, BackToTop, StickyHandoff, and a light port of the placement
   click measurement (guide_product_handoff). Vanilla JS, no dependencies.

   TOC strategy: built client-side from h2[id] in the article body so it can
   never drift from the content — and headings that LOST their ids to an
   admin rich-text-editor save get slugs generated here, so anchors and the
   rail survive an RTE round-trip. */
(function () {
  'use strict';

  /* ---------- chapterSummary.ts port ---------- */

  var SKIP_HEADING = [
    'related', 'related guides', 'explore', 'explore this topic',
    'quick answers', 'faq', 'faqs', 'newsletter', 'shop',
    'where to go next', 'the bottom line', 'sources', 'sources and review note',
  ];

  function cleanHeading(value) {
    return value.replace(/\s+/g, ' ').trim();
  }

  function isChapterHeading(text) {
    var lower = cleanHeading(text).toLowerCase();
    return !SKIP_HEADING.some(function (skip) {
      return lower === skip || lower.slice(-(skip.length + 1)) === ' ' + skip;
    });
  }

  function sentenceCase(value) {
    if (!value) return value;
    return value.charAt(0).toLowerCase() + value.slice(1);
  }

  function headingToQuestion(value) {
    var text = cleanHeading(value).replace(/[.:]+$/, '');
    if (!text) return text;
    if (text.slice(-1) === '?') return text;
    var lower = text.toLowerCase();
    if (lower.indexOf('how to ') === 0) return 'How do I ' + sentenceCase(text.slice(7)) + '?';
    if (lower.indexOf('when to ') === 0) return 'When should I ' + sentenceCase(text.slice(8)) + '?';
    // Brand-bridge headings ("How we approach…") stay statements.
    if (/^(how|why|what|when|where)\s+(we|our)\b/.test(lower)) return text;
    if (/^(what|why|when|where|who|which|how|is|are|can|could|should|do|does|did|will|would)\b/.test(lower)) {
      return text + '?';
    }
    return text;
  }

  /* github-slugger-compatible enough for our headings: lowercase, strip
     punctuation, spaces to hyphens. Only used when an id is MISSING. */
  function slugify(text) {
    return cleanHeading(text)
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-');
  }

  function chapterHeadings() {
    var prose = document.querySelector('.edu-prose');
    if (!prose) return [];
    var seen = {};
    return Array.prototype.slice.call(prose.querySelectorAll('h2')).map(function (h) {
      if (!h.id) {
        var base = slugify(h.textContent) || 'section';
        var slug = base;
        var i = 1;
        while (seen[slug] || document.getElementById(slug)) slug = base + '-' + i++;
        h.id = slug;
      }
      seen[h.id] = true;
      return h;
    }).filter(function (h) {
      return isChapterHeading(h.textContent);
    });
  }

  /* ---------- TOC (answer-box jump list + sticky rail) ---------- */

  function buildToc() {
    var headings = chapterHeadings();

    // In-flow "In this guide" list inside the answer box (capped at 8).
    var jumpBox = document.querySelector('[data-edu-jump-list]');
    if (jumpBox && headings.length > 0) {
      var ul = jumpBox.querySelector('ul');
      headings.slice(0, 8).forEach(function (h) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = headingToQuestion(h.textContent);
        li.appendChild(a);
        ul.appendChild(li);
      });
      jumpBox.hidden = false;
    }

    // Sticky rail list — only rendered with more than two chapters (the rail
    // container itself may still show for the rail product card).
    var rail = document.querySelector('[data-edu-toc]');
    if (rail && headings.length > 2) {
      var ol = rail.querySelector('ol');
      headings.forEach(function (h) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.className = 'edu-toc-link';
        a.setAttribute('data-toc-anchor', h.id);
        a.textContent = cleanHeading(h.textContent);
        li.appendChild(a);
        ol.appendChild(li);
      });
      rail.hidden = false;
      var railWrap = rail.closest('[data-edu-rail]');
      if (railWrap) railWrap.hidden = false;
    }

    initScrollSpy();
  }

  function initScrollSpy() {
    var links = Array.prototype.slice.call(document.querySelectorAll('[data-toc-anchor]'));
    if (!links.length) return;
    var slugs = links.map(function (l) { return l.getAttribute('data-toc-anchor'); });
    var headings = slugs.map(function (s) { return document.getElementById(s); }).filter(Boolean);
    if (!headings.length) return;

    var setActive = function (slug) {
      links.forEach(function (l) {
        l.classList.toggle('edu-toc-active', l.getAttribute('data-toc-anchor') === slug);
      });
    };

    var offset = anchorOffset();
    var visible = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visible[entry.target.id] = true;
        else delete visible[entry.target.id];
      });
      for (var i = 0; i < headings.length; i++) {
        if (visible[headings[i].id]) { setActive(headings[i].id); return; }
      }
      var lastAbove = null;
      for (var j = 0; j < headings.length; j++) {
        if (headings[j].getBoundingClientRect().top < offset + 36) lastAbove = headings[j].id;
        else break;
      }
      if (lastAbove) setActive(lastAbove);
    }, { rootMargin: '-' + offset + 'px 0px -60% 0px', threshold: 0 });
    headings.forEach(function (h) { io.observe(h); });
  }

  function anchorOffset() {
    var el = document.querySelector('.edu');
    if (!el) return 104;
    var v = getComputedStyle(el).getPropertyValue('--edu-anchor-offset');
    var probe = document.createElement('div');
    probe.style.position = 'absolute';
    probe.style.height = v;
    document.body.appendChild(probe);
    var px = probe.offsetHeight || 104;
    probe.remove();
    return px;
  }

  /* ---------- Back to top ---------- */

  function initBackToTop() {
    var btn = document.querySelector('[data-edu-backtotop]');
    var sentinel = document.querySelector('.edu-article h1, .edu h1');
    if (!btn || !sentinel) return;
    var io = new IntersectionObserver(function (entries) {
      btn.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '400px 0px 0px 0px', threshold: 0 });
    io.observe(sentinel);
    btn.addEventListener('click', function () {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      var h1 = document.querySelector('.edu-article h1, .edu h1');
      if (h1 && h1.focus) h1.focus();
    });
  }

  /* ---------- Sticky handoff bar (mobile) ---------- */

  function initStickyHandoff() {
    var bar = document.querySelector('[data-edu-handoff]');
    if (!bar) return;

    var key = 'roz-handoff-dismissed:' + location.pathname;
    function dismissed() {
      try { return sessionStorage.getItem(key) === '1'; } catch (e) { return false; }
    }
    function remember() {
      try { sessionStorage.setItem(key, '1'); } catch (e) { /* no-op */ }
    }
    if (dismissed()) { bar.remove(); return; }

    var h1 = document.querySelector('.edu-article h1');
    var shopThePost = document.querySelector('[data-shop-the-post]');
    var observers = [];
    var pastIntro = false;
    var atShop = false;

    function displayable() {
      return bar.isConnected && getComputedStyle(bar).display !== 'none';
    }

    function render() {
      var show = displayable() && pastIntro && !atShop;
      if (!show && bar.contains(document.activeElement)) {
        var target = document.querySelector('.edu-article h1');
        if (target && target.focus) target.focus();
      }
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('edu-handoff-open', show);
    }

    var railQuery = window.matchMedia('(min-width: 1200px)');
    (railQuery.addEventListener
      ? railQuery.addEventListener.bind(railQuery, 'change')
      : railQuery.addListener.bind(railQuery))(render);

    function observe(target, options, onChange) {
      if (!target) return;
      var io = new IntersectionObserver(function (entries) {
        onChange(entries[0].isIntersecting);
        render();
      }, options);
      io.observe(target);
      observers.push(io);
    }

    observe(h1, { rootMargin: '600px 0px 0px 0px', threshold: 0 }, function (hit) {
      pastIntro = !hit;
    });
    observe(shopThePost, { rootMargin: '0px 0px -20% 0px', threshold: 0 }, function (hit) {
      atShop = hit;
    });

    var x = bar.querySelector('[data-edu-handoff-dismiss]');
    if (x) x.addEventListener('click', function () {
      remember();
      var target = document.querySelector('.edu-article h1');
      if (target && target.focus) target.focus();
      observers.forEach(function (io) { io.disconnect(); });
      observers.length = 0;
      bar.classList.remove('is-visible');
      document.body.classList.remove('edu-handoff-open');
      bar.remove();
    });
  }

  /* ---------- Placement click measurement ---------- */
  // Light port of the Guide's guide_product_handoff event. The store's own
  // analytics own commerce; this only preserves the placement-level signal
  // (which placement, which article) the Amazon-destination test reads.
  // `link_position` and `guide_article` must be registered as event-scoped
  // custom dimensions in GA4 before reports can use them (already true for
  // the Guide's property; re-check on the store property).

  var HANDOFF = { prose: 1, resolver: 1, 'inline-card': 1, 'sticky-bar': 1, 'rail-card': 1, 'shop-the-post': 1 };

  function initClickMeasurement() {
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || typeof window.gtag !== 'function') return;
      var placementEl = a.closest('[data-cta]');
      if (!placementEl) return;
      var placement = placementEl.getAttribute('data-cta');
      if (!HANDOFF[placement]) return;
      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return; }
      var storeHost = url.hostname === 'rozhair.com' || url.hostname === 'www.rozhair.com'
        || url.hostname === location.hostname;
      var storeProduct = storeHost && /^\/(?:collections\/[^/]+\/)?products\/[^/]+\/?$/.test(url.pathname);
      var amazonProduct = /(^|\.)amazon\.com$/.test(url.hostname)
        && /\/(?:dp|gp\/product)\/[A-Z0-9]{10}(?:\/|$)/i.test(url.pathname);
      if (url.protocol !== 'https:' || (!storeProduct && !amazonProduct)) return;
      // Group collection-context links and Amazon slug URLs by the same
      // product. Keep query strings/fragments out of measurement; navigation
      // still uses the original href. Compact URLs fit GA4 parameter limits.
      var destinationPath = storeProduct
        ? url.pathname.replace(/^\/collections\/[^/]+/, '').replace(/\/$/, '')
        : '/dp/' + url.pathname.match(/\/(?:dp|gp\/product)\/([A-Z0-9]{10})(?:\/|$)/i)[1].toUpperCase();
      window.gtag('event', 'guide_product_handoff', {
        link_url: url.origin + destinationPath,
        outbound_domain: url.hostname,
        link_position: placement,
        guide_article: location.pathname,
      });
    }, true);
  }

  /* ---------- boot ---------- */

  function init() {
    buildToc();
    initBackToTop();
    initStickyHandoff();
    initClickMeasurement();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
